/*
Used to load discount on the <custom-promo> custom element.
Used to update class on each cart update.

snippets/custom-promotions.liquid is used to display the container and this file load the content

By Clément, from Galadrim.
*/

class customPromo extends HTMLElement {
  constructor() {
    super();
    // Used to apply a different layout on grid context : Only the most easily accessible discount
    this.context = this.dataset.context;

    this.hasPromo = false;

    if (!this.context) return;

    if (this.context == "main-product") {
      this.qttEl = this.closest(".product-main").querySelector(".quantity-selector__input");
      this.qttPlus = this.closest(".product-main").querySelector(".quantity-selector__button--plus");
      this.qttMinus = this.closest(".product-main").querySelector(".quantity-selector__button--minus");
    }

    if (this.dataset.logged == "true") this.build();

    this.updateProductItem();
  }

  build() {
    if (this.dataset.show == "false") return;
    this.querySelectorAll(".custom-promo-el").forEach(el => el.remove());
    try {
      const promos = this.getPromos();
      if (!promos) return;

      promos.forEach(promo => {
        this.buildPromo(promo);
      });

      const cartContainer = this.closest(".cart-item--inner");
      if (cartContainer) {
        cartContainer.style.setProperty("--promo-h", `${this.offsetHeight}px`);
      }

      this.updateFreeItemAvailability(window.Shopify.validIds);
    } catch (err) {
      console.error(this.dataset.handle, err);
    }
  }

  buildPromo(promo) {
    if (!promo) return;
    if (this.dataset.priceGroup !== "Z1") {
      // If the price group is not Z1, the only promotions allowed are destock promotions
      // They can be identified as percentage promotion with a value higher than 60%
      if (promo.type !== "PERCENTAGE" || promo.percentageDiscount.percentage < 60) return;
    }
    if (Array.isArray(promo.restrictedToPriceCodes)) {
      if (!promo.restrictedToPriceCodes.includes(this.dataset.priceCode)) return;
    }

    if (Array.isArray(promo.restrictedToCompanies)) {
      if (!promo.restrictedToCompanies.includes(this.dataset.companyId)) return;
    }
    // Build all the discounts and prepend them on the container
    const abs = promo.type === "FREE_ITEM" ? "CADEAU" : "OFFRE SPÉCIALE";

    let title;

    if (promo.type == "FREE_ITEM") title = `${promo.minimumQuantity}+${promo.freeItemDiscount.freeItemQuantity}`;
    else if (promo.type == "BUY_X_GET_Y")
      title = `${promo.minimumQuantity - promo.buyXGetYDiscount.freeItemQuantity}+${promo.buyXGetYDiscount.freeItemQuantity}`;
    else if (promo.type == "PERCENTAGE") title = `-${promo.percentageDiscount.percentage}%`;
    else if (promo.type == "FIXED_AMOUNT") title = `-${promo.fixedAmountDiscount.amount}€`;

    const el = document.createElement("div");
    el.dataset.id = promo.id;
    el.dataset.type = promo.type;
    el.classList = `custom-promo-el`;

    let repeat = "";
    if (promo.repeatQuantity > 0) {
      repeat = `
        <div class="cp-repeat">
          <svg viewBox="0 0 24 24" width="20" height="20"><path fill="#AA803C" d="M20,7.67839023 C20.3191373,7.67839023 20.6033578,7.8277818 20.7864517,8.06040161 L20.7868129,8.0569409 C21.552384,9.17836413 22,10.5338305 22,11.9937699 C22,15.7761413 18.9955544,18.857279 15.2414096,18.9840181 L15.0007869,18.9880738 L9.405,18.9874442 L10.7086806,20.2904605 L10.7863869,20.3776202 C11.0972124,20.7698625 11.0713103,21.3413068 10.7086806,21.7036822 C10.3481966,22.0639133 9.78096555,22.0916234 9.38867434,21.7868124 L9.29446701,21.7036822 L6.28926319,18.7005862 L6.21155682,18.6134265 C5.92663349,18.2538711 5.92465485,17.7437362 6.20562092,17.3820893 L6.28926319,17.2873645 L9.29446701,14.2842685 L9.38168782,14.2066167 C9.74149567,13.9218932 10.2519886,13.9199159 10.6138893,14.2006849 L10.7086806,14.2842685 L10.7863869,14.3714282 C11.0713103,14.7309837 11.0732889,15.2411186 10.7923228,15.6027654 L10.7086806,15.6974902 L9.415,16.988847 L15.0007869,16.9894766 C17.7617761,16.9894766 20,14.7528225 20,11.9937699 C20,10.9755377 19.6951563,10.0284557 19.1716955,9.23868979 C19.0637032,9.07917977 19,8.88586843 19,8.67768884 C19,8.12579146 19.4477153,7.67839023 20,7.67839023 Z M14.6250898,2.21140589 L14.7123106,2.28905775 L17.7175144,5.29215375 C18.0801441,5.6545291 18.1060462,6.22597341 17.7952208,6.61821576 L17.7175144,6.70537539 L14.7123106,9.70847139 C14.3217863,10.0987218 13.6886213,10.0987218 13.298097,9.70847139 C12.9354673,9.34609604 12.9095652,8.77465173 13.2203907,8.38240938 L13.298097,8.29524975 L14.595,6.9978595 L8.99921311,6.99806318 C6.23822395,6.99806318 4,9.23471726 4,11.9937699 C4,12.9117144 4.24775158,13.771834 4.6800791,14.5109974 L4.81525146,14.7290546 C4.93132393,14.8915256 5,15.0916491 5,15.3078015 C5,15.8596989 4.55228475,16.3071002 4,16.3071002 C3.66599922,16.3071002 3.37024338,16.143469 3.18863074,15.8920517 C2.43832928,14.7808948 2,13.4384851 2,11.9937699 C2,8.21139848 5.0044456,5.13026076 8.75859041,5.00352168 L8.99921311,4.99946596 L14.597,4.99926229 L13.298097,3.7022794 C12.9354673,3.33990404 12.9095652,2.76845974 13.2203907,2.37621739 L13.298097,2.28905775 C13.6607267,1.9266824 14.2325721,1.90079845 14.6250898,2.21140589 Z"> </path></svg>
        </div>
      `;
    }

    this.isApplied(el, promo);

    el.innerHTML = `
            <div class="cp-icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.66699 6.66669H6.67533M1.66699 4.33335L1.66699 8.06212C1.66699 8.46977 1.66699 8.67359 1.71304 8.86541C1.75387 9.03547 1.82121 9.19804 1.91259 9.34716C2.01566 9.51536 2.15979 9.65948 2.44804 9.94773L8.83856 16.3383C9.82861 17.3283 10.3236 17.8233 10.8944 18.0088C11.3966 18.1719 11.9374 18.1719 12.4395 18.0088C13.0104 17.8233 13.5054 17.3283 14.4954 16.3383L16.3386 14.4951C17.3286 13.5051 17.8236 13.0101 18.0091 12.4392C18.1722 11.9371 18.1722 11.3963 18.0091 10.8941C17.8236 10.3233 17.3286 9.8283 16.3386 8.83826L9.94804 2.44774C9.65979 2.15948 9.51566 2.01536 9.34746 1.91229C9.19834 1.82091 9.03577 1.75357 8.86571 1.71274C8.6739 1.66669 8.47007 1.66669 8.06242 1.66669L4.33366 1.66669C3.40024 1.66669 2.93353 1.66669 2.57701 1.84834C2.26341 2.00813 2.00844 2.2631 1.84865 2.5767C1.66699 2.93322 1.66699 3.39993 1.66699 4.33335ZM7.08366 6.66669C7.08366 6.89681 6.89711 7.08335 6.66699 7.08335C6.43687 7.08335 6.25033 6.89681 6.25033 6.66669C6.25033 6.43657 6.43687 6.25002 6.66699 6.25002C6.89711 6.25002 7.08366 6.43657 7.08366 6.66669Z" stroke="#AA803C" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
            <div class="cp-title">${title}</div>
            <div class="cp-desc">${promo.description}</div>
            <div class="cp-abs">${abs}</div>
            ${repeat}
        `;
    this.prepend(el);

    this.hasPromo = true;
  }

  isApplied(el) {
    el.classList.remove("active");
    const promoId = el.dataset.id;
    const appliedPromos = document.querySelector("#cart-applied-promos").value.split("///");
    appliedPromos.forEach(p => {
      if (p != "") {
        const handle = p.split("::")[0];
        p.split("::")[1]
          .split(",")
          .forEach(subP => {
            const id = subP.split(":")[1];
            if (handle == this.dataset.handle && id == promoId) el.classList.add("active");
          });
      }
    });
  }

  getPromos() {
    // Get the promo from the script tag on the snippet.
    const data = this.querySelector("#custom-promotions-data");
    if (!data) return null;
    const content = data.textContent.trim();
    if (!content || content == "") return null;
    // Parse it to JSON and return value
    return JSON.parse(content);
  }

  update() {
    if (this.dataset.context == "cart") return;

    this.querySelectorAll(".custom-promo-el").forEach(el => {
      this.isApplied(el);
    });
  }

  updateFreeItemAvailability(validIds) {
    const promoEls = this.querySelectorAll(".custom-promo-el");

    const isSet = validIds instanceof Set;

    promoEls.forEach(el => {
      if (el.dataset.type == "FREE_ITEM") {
        const promoId = el.dataset.id;

        const isValid = isSet ? validIds.has(promoId) : Array.isArray(validIds) ? validIds.includes(promoId) : false;

        if (isValid) {
          el.classList.remove("soldout");
        } else {
          el.classList.add("soldout");
        }
      }
    });
  }

  updateProductItem() {
    const badge = this.closest(".productitem")?.querySelector(".custom-promo-badge");
    if (!this.context == "grid" || !badge || !this.hasPromo) return;

    badge.style.display = "block";
  }
}
customElements.define("custom-promo", customPromo);

document.addEventListener("cart:newcart", () => document.querySelectorAll("custom-promo").forEach(el => el.update()));
window.addEventListener("free-item:checked-availability", e => {
  window.Shopify.validIds = e.detail.validDiscountIds || [];
  document.querySelectorAll("custom-promo").forEach(el => {
    el.updateFreeItemAvailability(window.Shopify.validIds);
  });
});
